import React from "react";
import { RouterProvider } from "react-router-dom";
import { Router } from "../src/views/home/routes/Navigation";
import "./App.css";
import Header from "./components/common/header/Header";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import store from "../src/store";
import { Provider } from "react-redux";
import Footer from "./components/common/footer/Footer";
import FeedBack from "./components/feedback/FeedBack";

function App() {
const theme = useTheme();
console.log=()=>null
  return (
    <Provider store={store}>
      <div className="App">
        <ThemeProvider theme={theme}>
          <FeedBack/>
          <Header />
          <RouterProvider router={Router} />
          <Footer />
        </ThemeProvider>
      </div>
    </Provider>
  );
}

export default App;
